export const ORetroIcon = () => {
  return <img src='/images/tokens/oretro.png' />
}
